import ApiService from "../../../common/api.service";

export async function GetCustomerNews({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("CUSTOMER_NEW_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/onboard", option);
    commit("CUSTOMER_NEW_SUCCESS", _response.data);
  } catch (error) {
    commit("CUSTOMER_NEW_ERROR", { result: error.message });
  }
}

// params
export async function GetCustomerNew({ commit }, params) {
  try {
    ApiService.init("heroku");
    commit("GET_CUSTOMER_NEW_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get(
      `/v1/onboard/${params.id}`
    );
    commit("GET_CUSTOMER_NEW_SUCCESS", _response);
  } catch (error) {
    commit("GET_CUSTOMER_NEW_ERROR", { result: error.message });
  }
}
